import React, { useContext } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { UserApiContext } from "./UserDetailsContext/UserDetailsContext";

const Unauthorized = ({
  message,
  showPremiumButton = true
}) => {
  const { userDetails } = useContext(UserApiContext);
  const history = useHistory();

  return (
    <div>
      <div className="container" style={{ width: "100%" }}>
        <div className="row justify-content-center">
          {userDetails?.display_name && (
            <h1>Hey {userDetails.display_name}!</h1>
          )}
        </div>

        <div className="row justify-content-center">
          <h4>
            {message
              ? message
              : "Your subscription does not include this service!"}
          </h4>
        </div>

        {showPremiumButton && (
          <div className="text-center">
            <button
              style={{ marginTop: "2%" }}
              className="btn btn-success"
              onClick={() => {
                history.push("/billing");
              }}
            >
              Premium Plans
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default withRouter(Unauthorized);
